import { ref } from 'vue'

/** Classe no <html> que liga o alto contraste (as regras ficam em resources/css/app.css). */
export const CLASSE_ALTO_CONTRASTE = 'alto-contraste'
/** Chave no localStorage; o app.blade.php lê a mesma chave para aplicar antes de pintar a tela. */
export const CHAVE_ALTO_CONTRASTE = 'altoContraste'

const ativo = ref(false)

const raiz = () => (typeof document === 'undefined' ? null : document.documentElement)

/**
 * Alto contraste do site público: fundo preto, texto branco e links amarelos. A escolha fica
 * guardada no navegador e vale para todas as páginas.
 */
export function useAltoContraste() {
    // A classe pode ter sido aplicada pelo script do <head>: o estado parte dela.
    ativo.value = Boolean(raiz()?.classList.contains(CLASSE_ALTO_CONTRASTE))

    function definir(ligar) {
        ativo.value = ligar
        raiz()?.classList.toggle(CLASSE_ALTO_CONTRASTE, ligar)
        try {
            if (ligar) localStorage.setItem(CHAVE_ALTO_CONTRASTE, '1')
            else localStorage.removeItem(CHAVE_ALTO_CONTRASTE)
        } catch {
            // sem armazenamento (ex.: aba anônima com bloqueio): vale até recarregar a página
        }
    }

    return {
        ativo,
        alternar: () => definir(!ativo.value),
        definir,
    }
}
